(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('horizontal-slider')) {
    class HorizontalSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hs__track');
        var groups = this.querySelectorAll('[data-group]');
        if (!this.track || !groups.length) return;
        this.base = groups[0];
        for (var i = 1; i < groups.length; i++) groups[i].remove();

        this.layout = this.layout.bind(this);
        this.layout();

        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(this.layout);
          this.observer.observe(this);
          this.observer.observe(this.base);
        } else {
          window.addEventListener('resize', this.layout);
        }
        this.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.layout, { once: true });
        });
        window.addEventListener('load', this.layout, { once: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.layout);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.layout);
      }

      layout() {
        if (!this.base) return;
        var width = this.base.getBoundingClientRect().width;
        if (!width) return;
        var need = Math.max(2, Math.ceil(this.clientWidth / width) + 1);
        var groups = this.track.querySelectorAll('[data-group]');
        while (groups.length < need) {
          var clone = this.base.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('[data-block-id], [data-shopify-editor-block]').forEach((el) => {
            el.removeAttribute('data-block-id');
          });
          this.track.appendChild(clone);
          groups = this.track.querySelectorAll('[data-group]');
        }
        while (groups.length > need) {
          groups[groups.length - 1].remove();
          groups = this.track.querySelectorAll('[data-group]');
        }
        var speed = Number(this.dataset.speed) || 80;
        this.style.setProperty('--hs-shift', width + 'px');
        this.style.setProperty('--hs-duration', (width / speed) + 's');
      }
    }
    customElements.define('horizontal-slider', HorizontalSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kundenbewertungen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-section')) {
    class TestimonialsSection extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.cards = Array.prototype.slice.call(this.track.querySelectorAll('.ts__card'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.start(); }));
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.go(this.index() - 1, true); this.start(); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.go(this.index() + 1, true); this.start(); });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.onSelect = (e) => {
          var card = e.target && e.target.closest ? e.target.closest('.ts__card') : null;
          if (card && this.cards.indexOf(card) > -1) this.go(this.cards.indexOf(card));
        };
        document.addEventListener('shopify:block:select', this.onSelect);

        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.track);
        }
        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }

      isSlider() {
        return this.track.scrollWidth > this.track.clientWidth + 2;
      }

      step() {
        if (this.cards.length > 1) return this.cards[1].offsetLeft - this.cards[0].offsetLeft || this.cards[0].offsetWidth;
        return this.cards[0] ? this.cards[0].offsetWidth : 1;
      }

      perView() {
        return Math.max(1, Math.round(this.track.clientWidth / (this.step() || 1)));
      }

      maxIndex() {
        return Math.max(0, this.cards.length - this.perView());
      }

      index() {
        return Math.round(this.track.scrollLeft / (this.step() || 1));
      }

      go(i, wrap) {
        var max = this.maxIndex();
        if (wrap) {
          if (i < 0) i = max;
          if (i > max) i = 0;
        }
        i = Math.max(0, Math.min(i, max));
        this.track.scrollTo({ left: i * this.step(), behavior: 'smooth' });
      }

      update() {
        var current = this.index();
        var max = this.maxIndex();
        this.dots.forEach((dot, i) => {
          dot.hidden = i > max;
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.cards.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var seconds = parseFloat(this.dataset.speed) || 5;
        this.timer = setInterval(() => {
          if (this.isSlider()) this.go(this.index() + 1, true);
        }, seconds * 1000);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
    customElements.define('testimonials-section', TestimonialsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('reviews-header-slider')) {
    class ReviewsHeaderSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.slides = Array.from(this.track.children);
        this.timer = null;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.updateDots());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.goTo(index);
            this.start();
          });
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.updateDots();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      get index() {
        const width = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / width);
      }

      goTo(index) {
        const width = this.track.clientWidth;
        this.track.scrollTo({ left: index * width, behavior: 'smooth' });
      }

      updateDots() {
        const current = this.index;
        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }

      start() {
        this.stop();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || reduceMotion) return;

        const seconds = parseFloat(this.dataset.speed) || 5;
        this.timer = setInterval(() => {
          const next = (this.index + 1) % this.slides.length;
          this.goTo(next);
        }, seconds * 1000);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('reviews-header-slider', ReviewsHeaderSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('results-section')) {
    class ResultsSection extends HTMLElement {
      connectedCallback() {
        if (this.dataset.animate !== 'true') return;
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify && window.Shopify.designMode) return;

        this.rings = Array.prototype.slice.call(this.querySelectorAll('.rs__ring-fg'));
        this.pcts = Array.prototype.slice.call(this.querySelectorAll('.rs__pct'));
        this.rings.forEach((ring) => { ring.style.strokeDashoffset = '100'; });
        this.pcts.forEach((el) => { el.textContent = '0%'; });

        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.observer.disconnect();
            this.play();
          }
        }, { threshold: 0.3 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      play() {
        this.rings.forEach((ring) => {
          ring.style.strokeDashoffset = ring.dataset.offset;
        });
        var duration = 1400;
        var start = null;
        var step = (now) => {
          if (start === null) start = now;
          var t = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          this.pcts.forEach((el) => {
            el.textContent = Math.round(Number(el.dataset.target) * eased) + '%';
          });
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    }
    customElements.define('results-section', ResultsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-header-slider')) {
    class ReviewsHeaderSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.slides = Array.from(this.track.children);
        this.timer = null;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.updateDots());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.goTo(index);
            this.start();
          });
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.updateDots();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      get index() {
        const width = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / width);
      }

      goTo(index) {
        const width = this.track.clientWidth;
        this.track.scrollTo({ left: index * width, behavior: 'smooth' });
      }

      updateDots() {
        const current = this.index;
        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }

      start() {
        this.stop();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || reduceMotion) return;

        const seconds = parseFloat(this.dataset.speed) || 5;
        this.timer = setInterval(() => {
          const next = (this.index + 1) % this.slides.length;
          this.goTo(next);
        }, seconds * 1000);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('reviews-header-slider', ReviewsHeaderSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
